import Vue from "vue";
import VueRouter from "vue-router";
import { PositionResult } from "vue-router/types/router";

import routes, { Step1Route, Step2Route, ThankYouRoute } from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(): PositionResult {
        // Scroll to the top after each navigation
        // See https://router.vuejs.org/guide/advanced/scroll-behavior.html#scroll-behavior
        return { x: 0, y: 0 };
    }
});

export default router;

export { Step1Route, Step2Route, ThankYouRoute };
